module.exports = __webpack_public_path__ + "img/warning.57add295.png";